import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";

const values = [
  {
    icon: "ri-snowy-line",
    title: "专注冬日题材",
    text: "我们只做一件事：把散落在各处、容易被忽略的雪景、冬日、雪国、冰雪、冬物语与雪女题材漫画，认真地收进同一个温暖的地方。",
  },
  {
    icon: "ri-eye-line",
    title: "高清点开即读",
    text: "统一采用高清原图渲染，无需下载、无需注册，点开就能读。我们希望阅读的阻力越小越好，把时间留给故事本身。",
  },
  {
    icon: "ri-list-check-3",
    title: "分类清晰不迷路",
    text: "六大冬日题材精细分类，加上编辑精选与每周更新汇总，让你追更不迷路，冷门佳作也能一找即得。",
  },
  {
    icon: "ri-heart-line",
    title: "守护每一份热爱",
    text: "冬日漫画是小众而美好的存在。我们尊重作者创作，尊重每一位读者的热爱，也谨慎对待版权与合规。",
  },
];

const principles = [
  "内容为本，题材为先",
  "尊重版权，遵守规范",
  "分类精细，检索友好",
  "界面克制，阅读舒适",
  "持续更新，长期主义",
];

export default function About() {
  return (
    <Layout>
      <Seo
        title="关于我们 - 吹雪漫画网"
        description="了解吹雪漫画网的品牌定位、发展理念与内容原则。吹雪漫画网专注雪景、冬日、雪国、冰雪、冬物语与雪女等题材漫画的在线阅读，让每一份冬日热爱都有处安放。"
        keywords="吹雪漫画网,关于我们,雪景漫画,冬日漫画,雪国漫画,冬物语,冰雪漫画,雪女漫画"
        canonical="https://secretom.github.io/about"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于吹雪漫画网",
            url: "https://secretom.github.io/about",
            description: "吹雪漫画网的品牌定位、发展理念与内容原则。",
          },
        ]}
      />

      {/* 页头 */}
      <section className="relative flex min-h-[320px] w-full items-center overflow-hidden pt-24 md:min-h-[380px]">
        <div className="absolute inset-0 bg-background-100"></div>
        <div className="absolute -left-16 top-10 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl"></div>
        <div className="absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl"></div>
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-sm text-primary-500">
            <i className="ri-snowy-line"></i> 关于吹雪漫画网
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-5xl">
            把每一场雪，都读成故事
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            吹雪漫画网是一个专注冬日题材的漫画在线阅读站。我们相信，雪景、雪国、冰雪与雪女传说里藏着的浪漫与温度，值得被认真收录、被更多人看见。
          </p>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-information-line text-primary-500"></i> 我们是谁
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              吹雪漫画网成立于编辑部几位雪国爱好者的一个小小约定：市面上好看的冬日漫画散落各处、难以分类，也没有一个专门为「雪」而生的阅读空间。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              于是我们把雪景漫画、冬日漫画、雪国漫画、冬物语、冰雪漫画、雪女漫画等题材汇集于此，用高清原图、清晰分类与稳定的更新，为喜欢冰雪故事的人打造一处可以随时走进、安静阅读的「雪中书房」。
            </p>
            <div className="mt-7 grid grid-cols-3 gap-3">
              {[
                { n: "1200+", l: "收录作品" },
                { n: "6", l: "冬日题材" },
                { n: "全年", l: "持续更新" },
              ].map((s) => (
                <div key={s.l} className="rounded-lg border border-background-200/60 bg-background-100 p-4 text-center">
                  <p className="font-heading text-2xl font-bold text-primary-500">{s.n}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200/60 bg-background-100 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100/80 text-xl text-primary-500">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 发展理念 */}
      <section className="bg-background-100/70">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
            <i className="ri-compass-3-line text-accent-500"></i> 发展理念
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {principles.map((p, i) => (
              <div key={p} className="relative rounded-lg border border-background-200/60 bg-background-100 p-5">
                <span className="font-heading text-3xl font-black text-background-300/80">{String(i + 1).padStart(2, "0")}</span>
                <p className="mt-3 font-heading text-base font-semibold text-foreground-950">{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 内容原则 */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200/60 bg-background-100 p-7">
            <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-shield-check-line text-primary-500"></i> 我们的内容原则
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>坚持只收录有明确来源、可公开阅读的冬日题材作品。</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>分类与标签如实反映内容，不做标题党、不误导读者。</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>更新信息及时同步，让追更体验稳定可靠。</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>尊重版权与相关规范，保持内容合规、界面克制。</li>
            </ul>
          </div>

          <div className="rounded-lg border border-background-200/60 bg-background-100 p-7">
            <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-mail-line text-accent-500"></i> 联系我们
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              无论你是想反馈阅读问题、建议补充题材，还是寻求合作，都欢迎通过以下方式与我们联系。你的每一条建议，都会成为吹雪漫画网变得更好的雪。
            </p>
            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-500"></i>hello@chuixue-manga.example.com</li>
              <li className="flex items-center gap-2"><i className="ri-question-line text-primary-500"></i>常见问题：/faq</li>
              <li className="flex items-center gap-2"><i className="ri-chat-3-line text-primary-500"></i>反馈表单：/contact</li>
            </ul>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600">
              给我们写信 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}